class ProductNavigation extends HTMLElement {
  constructor() {
    super()
    this.btns = this.querySelectorAll('.nav-btn')
    this.mainHeader = document.querySelector('.cc-header')
    this.navContainer = this.querySelector('.product-navigation__container')
    this.sections = []

    this.checkTargetSection()

    this.btns.forEach((btn) => {
      btn.addEventListener('click', this.onBtnClick.bind(this))
    })

    window.addEventListener('scroll', this.activeOnScroll.bind(this))
  }

  onBtnClick(e) {
    const btn = e.target
    const targetSection = document.querySelector(`#${btn.dataset.sectionId}`)
    const currentOffset = this.getDynamicOffset(btn)
    const targetPosition = targetSection.offsetTop - currentOffset

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth',
    })
  }

  getDynamicOffset(btn) {
    let offset = this.offsetHeight

    if (btn && btn.dataset.sectionId === 'main-product') {
      offset = 0
    }

    const headerStyle = window.getComputedStyle(this.mainHeader)
    const isHeaderSticky = headerStyle.position === 'sticky' || headerStyle.position === 'fixed'

    const headerRect = this.mainHeader.getBoundingClientRect()
    const isHeaderVisible = headerRect.bottom > 0

    if (isHeaderSticky && isHeaderVisible) {
      offset += this.mainHeader.offsetHeight
    }

    return offset
  }

  checkTargetSection() {
    this.btns.forEach((btn) => {
      const targetId = btn.dataset.sectionId
      if (!targetId) {
        btn.style.display = 'none'
        return
      }

      const targetSection = document.querySelector(`#${targetId}`)
      if (!targetSection) {
        btn.style.display = 'none'
        return
      }

      this.sections.push(targetSection)
    })
  }

  activeOnScroll() {
    const topOffset = this.getDynamicOffset()

    this.sections.forEach((section) => {
      if (section.getAttribute('id') === 'main-product') return

      const sectionTopOffset = section.offsetTop - topOffset
      const sectionHeight = parseInt(getComputedStyle(section).height)
      const sectionBottomOffset = sectionTopOffset + sectionHeight
      const relatedBtn = this.querySelector(`.nav-btn[data-section-id=${section.getAttribute('id')}]`)

      if (Math.ceil(window.pageYOffset) >= sectionTopOffset && Math.ceil(window.pageYOffset) <= sectionBottomOffset) {
        if (!relatedBtn.classList.contains('active')) {
          relatedBtn.classList.add('active')
          this.scrollToActiveButton(relatedBtn)
        }
      } else {
        relatedBtn.classList.remove('active')
      }
    })
  }

  scrollToActiveButton(btn) {
    if (!this.navContainer) return

    const containerRect = this.navContainer.getBoundingClientRect()
    const btnRect = btn.getBoundingClientRect()

    const targetScroll = this.navContainer.scrollLeft + (btnRect.left - containerRect.left)

    this.navContainer.scrollTo({
      left: targetScroll,
      behavior: 'smooth',
    })
  }
}

customElements.define('product-navigation', ProductNavigation)
